import { render, staticRenderFns } from "./StaffEnrollmentRedirect.vue?vue&type=template&id=446e2f26&scoped=true&"
import script from "./StaffEnrollmentRedirect.vue?vue&type=script&lang=js&"
export * from "./StaffEnrollmentRedirect.vue?vue&type=script&lang=js&"
import style0 from "./StaffEnrollmentRedirect.vue?vue&type=style&index=0&id=446e2f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e2f26",
  null
  
)

export default component.exports